export enum OpportunityStatusFilter {
    All = 'All',
    UnderReview = 'UnderReview',
    Rejected = 'Rejected',
    Active = 'Active',
    Expired = 'Expired',
    Canceled = 'Canceled'
}